// src/components/FooterSection.js
import React from 'react';
import { Box, Typography, IconButton, Link } from '@mui/material';
import { FaFacebookF, FaInstagram, FaTiktok, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';
import ZillowIcon from './ZillowIcon';

const FooterSection = () => {
  return (
    <Box
      component="footer"
      sx={{
        background: 'linear-gradient(135deg, #1a365d, #2c4a7c)', // Subtle navy blue gradient
        color: '#fff',
        padding: '40px 0',
        marginTop: 'auto',
      }}
    >
      <Box
        sx={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: '0 20px',
        }}
      >
        {/* Contact Information */}
        <Box sx={{ marginBottom: '20px', textAlign: 'center' }}>
          <Typography variant="h6" sx={{ marginBottom: '10px' }}>
            Contact Information
          </Typography>
          <Typography variant="body1">
            <FaPhone /> 1-248-989-5737
          </Typography>
          <Typography variant="body1">
            <FaEnvelope /> <Link href="mailto:americandreamrealty26@gmail.com" sx={{ color: '#fff', textDecoration: 'none', '&:hover': { color: '#c9302c' } }}>americandreamrealty26@gmail.com</Link>
          </Typography>
          <Typography variant="body1">
            <FaMapMarkerAlt /> Serving Southeast Michigan
          </Typography>
          <Typography variant="body1" sx={{ marginTop: '12px' }}>
            <Link
              href="https://americandreamrealty.homes"
              target="_blank"
              rel="noopener"
              sx={{
                color: '#fff',
                textDecoration: 'none',
                padding: '8px 16px',
                border: '1px solid rgba(255,255,255,0.5)',
                borderRadius: '4px',
                display: 'inline-block',
                transition: 'all 0.3s',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  borderColor: '#fff',
                }
              }}
            >
              Visit Our Brokerage →
            </Link>
          </Typography>
        </Box>

        {/* Social Media Heading */}
        <Typography variant="h6" sx={{ marginBottom: '20px', color: '#fff' }}>
          Find us on social media
        </Typography>

        {/* Social Media Icons */}
        <Box sx={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
          <IconButton
            component={Link}
            href="https://www.facebook.com/GaneshalpineRealtor/"
            target="_blank"
            rel="noopener"
            aria-label="Facebook"
            sx={{ color: '#4267B2', fontSize: '2rem' }}
          >
            <FaFacebookF size={40} />
          </IconButton>
          <IconButton
            component={Link}
            href="https://www.instagram.com/realtorganeshalpine?igsh=ZTN4MmJiOGVlcDd6"
            target="_blank"
            rel="noopener"
            aria-label="Instagram"
            sx={{ color: '#E4405F', fontSize: '2rem' }}
          >
            <FaInstagram size={40} />
          </IconButton>
          <IconButton
            component={Link}
            href="https://g.co/kgs/2DwmCsr"
            target="_blank"
            rel="noopener"
            aria-label="Google Reviews"
            sx={{ fontSize: '2rem' }}
          >
            <FcGoogle size={40} />
          </IconButton>

          <IconButton
            component={Link}
            href="https://www.tiktok.com/@neupaneganeshrealtor"
            target="_blank"
            rel="noopener"
            aria-label="TikTok"
            sx={{ color: '#000000', fontSize: '2rem' }}
          >
            <FaTiktok size={40} />
          </IconButton>
          <IconButton
            component={Link}
            href="https://www.zillow.com/profile/realtorganesh"
            target="_blank"
            rel="noopener"
            aria-label="Zillow"
            sx={{ color: '#0074E4', fontSize: '2rem' }}
          >
            <ZillowIcon width={40} height={40} />
          </IconButton>
        </Box>

        {/* Copyright */}
        <Typography variant="body2" align="center" sx={{ color: 'rgba(255,255,255,0.8)' }}>
          © {new Date().getFullYear()} American Dream Realty. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default FooterSection;
